
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balances/positions",
      function () {
        return require("private-next-pages/balances/positions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/balances/positions"])
      });
    }
  